import React from 'react'
import PatreonButtonImg from '../assets/patreon-button.png'
export default () => <a  href="https://www.patreon.com/bePatron?u=7263362">
    <img width="170" height="40" src={PatreonButtonImg} alt="Become a Patron!"/>
</a>
